<template>
  <div class="mymsg">
    <!-- 添加项目 -->
    <el-dialog
      title="添加项目"
      :visible.sync="dialogadd"
      width="600px"
      style="text-align:left"
    >
      <div class="dialog">
        <div style="font-size:16px;margin-bottom:16px;font-weight:600">项目名称</div>
        <el-input
          v-model="pro_name_add"
          placeholder="请输入10位以内汉字或字符"
          maxlength="10"
        ></el-input>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogadd = false">取 消</el-button>
        <el-button
          type="primary"
          @click="addDepartment"
        >确 定</el-button>
      </div>
    </el-dialog>
    <div class="container">
      <div>
        <div class="box">
          <div class="searchbox">
            <div>
              <span>项目名称</span>
              <el-input
                v-model="pro_name"
                style="width:220px;margin:0 20px 0 10px"
                @input="search"
                clearable
              ></el-input>

              <el-button
                type="info"
                style="background-color:#eceff2;color:#747981;"
                @click="search"
                size="medium"
              >查询</el-button>
            </div>
            <el-button
              type="primary"
              @click="dialogadd = true;department_name_add=''"
              :disabled="module_id_array[0]?!module_id_array.includes('292'):false"
              icon="el-icon-plus"
            >添加项目</el-button>
          </div>

          <div style="border: solid 1px #c9cbd6;">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%;min-width:1000px;"
              :header-cell-style="{background:'#F5F5F5'}"
            >
              <el-table-column
                label="项目名称"
                prop="pro_name"
              ></el-table-column>

              <el-table-column
                label="销售价格"
                prop="price"
              ></el-table-column>
              <el-table-column
                label="推荐奖励"
                prop="reward_price"
              ></el-table-column>
              <el-table-column label="状态">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.status"
                    active-color="#669961"
                    @change="value=>{updateStatus(value,scope.row.pro_id)}"
                    :disabled="module_id_array[0]?!module_id_array.includes('291'):false"
                  ></el-switch>
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="toDetail(scope.row.pro_id)"
                    :disabled="module_id_array[0]?!module_id_array.includes('290'):false"
                  >查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              style="margin:20px 0"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import clinic from '../../../api/clinic';
import marketing from '../../../api/marketing';
import platform from '../../../api/platform';
import moment from 'moment';
import axios from '../../../service/axios/axios';
import _ from 'lodash';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      pro_name: '',
      pro_name_add: '',
      dialogadd: false
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        pro_name: this.pro_name,
        pro_type: 1
      };
      marketing.getProductlists(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.status = item.status ? true : false;
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //添加项目
    addDepartment() {
      if (!this.pro_name_add) {
        this.$message.error('请输入项目名称');
        return false;
      }
      let data = {
        pro_type: 1,
        pro_name: this.pro_name_add
      };
      marketing.addproduct(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功');
          this.dialogadd = false;
          this.getList();
        }
      });
    },
    //更改状态
    updateStatus(value, pro_id) {
      if (value) {
        this.$confirm('是否开启该项目？', '提示', {
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            let status = 1;
            marketing.updateproductstatus({ pro_id, status }).then((res) => {
              if (res.code == 0) {
                this.$message.success('项目已开启');
                this.getList();
              }
            });
          })
          .catch(() => {
            this.getList();
          });
      } else {
        this.$confirm('是否关闭该项目？', '提示', {
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            let status = 0;
            marketing.updateproductstatus({ pro_id, status }).then((res) => {
              if (res.code == 0) {
                this.$message.success('项目已关闭');
                this.getList();
              }
            });
          })
          .catch(() => {
            this.getList();
          });
      }
    },
    toDetail(pro_id) {
      this.$router.push({
        path: 'prodetail',
        query: {
          pro_id
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.dialog {
  padding: 30px 30px 0;
}
</style>

